<div class="container-fluid cw-background">
  <mat-card class="mat-elevation-z8 my-3">
    <mat-card-title class="title-page">Configurable Options List</mat-card-title>
    <button
      *ngIf="currentUser.hasRight(['admin']) && currentUser.isGlobal()"
      mat-fab
      class="create"
      color="accent"
      (click)="onAddConfigurableOption()"
    >
      <mat-icon>add</mat-icon>
    </button>
    <mat-card-content class="mt-12">
      <app-data-table
        *ngIf="tableConfig"
        [config]="tableConfig"
        (getData)="configurableOptionTableService.getConfigurableOptions($event)"
        (updateData)="configurableOptionTableService.update($event)"
      ></app-data-table>
    </mat-card-content>
  </mat-card>
</div>
